export default __webpack_public_path__ + "static/media/elevate-blk-1.7a4e3b84.png";